module.exports = __webpack_public_path__ + "media/images/bg/patterns/shape-blue-0b594146da08b656535fe9610e2f82d1.svg";